import Insight from "../Insight/Insight";

class Person {
  constructor(contentfulNode) {
    this.name = contentfulNode?.name ?? contentfulNode?.fields?.name;
    this.metaDescription = contentfulNode?.metaDescription ?? contentfulNode?.fields?.metaDescription;
    this.avatar = {
      fluid: contentfulNode?.avatar?.gatsbyImageData,
      url: contentfulNode?.fields?.avatar?.fields?.file?.url ?? contentfulNode?.url
    }
    this.title = contentfulNode?.title ?? contentfulNode?.fields?.title;
    this.subtitle = contentfulNode?.subtitle ?? contentfulNode?.fields?.subtitle;
    this.slug = contentfulNode?.slug ?? contentfulNode?.fields?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug;
    this.videoLandscape = contentfulNode?.videoLandscape;
    this.bio = contentfulNode?.bio?.raw && contentfulNode.bio;
    this.linkedin = contentfulNode?.linkedin ?? contentfulNode?.fields?.linkedin;
    this.leader = contentfulNode?.leader;
    this.recentInsights = contentfulNode?.recentInsights
      ? contentfulNode?.recentInsights.map(insight => new Insight(insight))
      : null;
    this.officeLocation = contentfulNode?.officeLocation ?? contentfulNode?.fields?.officeLocation;
    this.expert = contentfulNode?.expert ?? contentfulNode?.fields?.expert;
    this.expertise = contentfulNode?.fields?.expertise ?? contentfulNode?.expertise ?? [];
  }
}

export default Person;
